// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_26rNr","content":"index_content_3v-hL","flag":"index_flag_3tLKG","tasks":"index_tasks_3eqfF","list-row":"index_list-row_1XEMb"};